/*
  @layer  core
  @name   Panier — ancrage du panneau sous l'en-tête
  @deps   assets/cart-drawer.js (Dawn) pour l'ouverture ; assets/enet-core-cart-dropdown.css
  @i18n   aucune — aucun texte n'est produit ici

  Ce fichier ne fait qu'**une** chose : écrire dans `--enet-header-bottom` la position du bas de
  l'en-tête, pour que la feuille puisse caler le panneau du panier juste dessous en desktop.

  POURQUOI UNE MESURE, ET PAS UNE VALEUR EN DUR.

  L'en-tête fait trois rangées dont deux sont conditionnelles : la barre d'annonce se désactive
  depuis l'éditeur, et la rangée de navigation peut passer sur deux lignes selon le menu. Une
  hauteur écrite en dur serait fausse dès la première de ces variations, et personne ne ferait le
  lien entre le menu modifié et le panneau décalé.

  POURQUOI PAS LA VARIABLE DE DAWN.

  Dawn a déjà `--header-bottom-position-desktop`, mais elle n'est écrite qu'au **premier basculement
  d'un menu déroulant** (`details-disclosure.js`) — et son mega menu s'en accommode avec un repli de
  20 rem parce qu'il est justement ouvert depuis ce menu. Le panier, lui, peut être cliqué en
  premier : la variable serait vide et le panneau tomberait sur le repli. On mesure donc soi-même,
  sans toucher au fichier de Dawn ni à sa variable.

  `getBoundingClientRect().bottom` et non `offsetHeight` : l'en-tête est collant, et c'est bien sa
  position **à l'écran** qui compte. Quand il est masqué par un défilement vers le bas, le bas
  calculé devient négatif — d'où la borne basse, qui garde le panneau dans le cadre au lieu de le
  faire déborder par le haut.

  Aucun écouteur sur l'ouverture du panier : un `ResizeObserver` sur l'en-tête plus un écouteur de
  défilement suffisent, et la variable est donc déjà juste au premier clic. C'est ce qui évite le
  saut de position que produirait une mesure faite au moment de l'ouverture.
*/

(() => {
  'use strict';

  const MIN_OFFSET = 16;

  const header = document.querySelector('.section-header') || document.querySelector('.header-wrapper');
  if (!header) return;

  let frame = null;

  const measure = () => {
    frame = null;
    const bottom = Math.max(Math.round(header.getBoundingClientRect().bottom), MIN_OFFSET);
    document.documentElement.style.setProperty('--enet-header-bottom', `${bottom}px`);
  };

  // Le défilement peut déclencher la mesure à chaque image : elle est donc repoussée à la
  // prochaine frame, et une seule est jamais en attente.
  const schedule = () => {
    if (frame === null) frame = window.requestAnimationFrame(measure);
  };

  measure();

  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(header);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
})();
